import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth.slice";
import { loaderReducer } from "./loader.slice";

export * from "./auth.slice";
export * from "./loader.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    load: loaderReducer,
  },
});
